import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import SourceEditor from "./royalty-partials/source-editor";
import ProductEditor from "./royalty-partials/product-editor";
import SubProductEditor from "./royalty-partials/subproduct-editor";
import UnsavedChanges from "partials/unsaved-changes";

const EDITOR_NAMES = {
  source: "source",
  product: "product",
  subproduct: "subproduct",
}

function RoyaltySettingsForm() {
  const history = useHistory();

  const [showSourceEditor, setShowSourceEditor] = useState(true);
  const [showProductEditor, setShowProductEditor] = useState(false);
  const [showSubProductEditor, setShowSubProductEditor] = useState(false);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [currentEditor, setCurrentEditor] = useState("");

  const goBack = () => {
    history.push("/admin-royalty-pricing");
  };

  const handleChildrenUnsavedEdits = (_val) => {
    setHasUnsavedChanges(_val);
  }

  const selectEditor = (editor) => {
    if(editor !== currentEditor) {
      history.push(`/admin-royalty-settings-form#${editor}`); 
    }
  };

  useEffect(() => {
    let _hash = history.location.hash;
    let show_editor = EDITOR_NAMES.source;
    if(_hash && _hash.length) {
      show_editor = EDITOR_NAMES[_hash.replace("#", "")];
    }
    setCurrentEditor(show_editor);

    // reset all
    setShowSourceEditor(false);
    setShowProductEditor(false);
    setShowSubProductEditor(false);

    // show the selection
    switch (show_editor) {
      case EDITOR_NAMES.source:
        setShowSourceEditor(true);
        break;
      case EDITOR_NAMES.product:
        setShowProductEditor(true);
        break;
      case EDITOR_NAMES.subproduct:
        setShowSubProductEditor(true);
        break;
      default:
        setShowSourceEditor(true);
        break;
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history.location.hash])

  return (
    <div className="page admin-page royalty-form-page">
      <div className="list-header sticky-page-header">
        <button type="button" className="new-button" onClick={goBack}>
          <i className="bi bi-chevron-left" /> Back
        </button>
        <h1>Royalty Pricing Settings</h1>
        <i className="spacer" />
      </div>
      <div className="main-section">
        <div className="royalty-nav-selector">
          <button
            className={showSourceEditor ? "active-btn" : null}
            onClick={() => selectEditor(EDITOR_NAMES.source)}
            disabled={currentEditor === EDITOR_NAMES.source}
          >
            Source
          </button>
          <button
            className={showProductEditor ? "active-btn" : null}
            onClick={() => selectEditor(EDITOR_NAMES.product)}
            disabled={currentEditor === EDITOR_NAMES.product}
          >
            Product
          </button>
          <button
            className={showSubProductEditor ? "active-btn" : null}
            onClick={() => selectEditor(EDITOR_NAMES.subproduct)}
            disabled={currentEditor === EDITOR_NAMES.subproduct}
          >
            Sub-Product
          </button>
        </div>
        {showSourceEditor ? <SourceEditor handleChanges={handleChildrenUnsavedEdits} /> : ""}
        {showProductEditor ? <ProductEditor handleChanges={handleChildrenUnsavedEdits} /> : ""}
        {showSubProductEditor ? <SubProductEditor handleChanges={handleChildrenUnsavedEdits} /> : ""}
      </div>
      <UnsavedChanges hasUnsavedChanges={hasUnsavedChanges} />
    </div>
  );
}

export default RoyaltySettingsForm;